// Property Factory
export const CustomerFactory = (customerData = {}) => {
    return {
      companyId: customerData.companyId || "",
      companyName: customerData.companyName || "",
      address1: customerData.address1 || "",
      address2: customerData.address2 || "",
      address3: customerData.address3 || "",
      city: customerData.city || "",
      postCode: customerData.postCode || "",
      state: customerData.state || "",
      country: customerData.country || "",
      adminUsername: customerData.adminUsername || "",
      adminEmailAddress: customerData.adminEmailAddress || "",
      companyDomain: customerData.companyDomain || "",
      subscriptionPlan: customerData.subscriptionPlan || "",
      subscriptionRenew: customerData.SubscriptionRenew || customerData.subscriptionRenew || "",
      aiSearch: customerData.aiSearch !== undefined ? customerData.aiSearch : false,
      url: customerData.url || "",
      primaryColor: customerData.primaryColor || "",
      secondaryColor: customerData.secondaryColor || "",
      tertiaryColor: customerData.tertiaryColor || "",
    };
  };

export const CustomerEditFactory = (customerData = {}) => {
  return {
      companyId: customerData.customerId || "",
      companyName: customerData.customerName || "",
      address1: customerData.address1 || "",
      address2: customerData.address2 || "",
      address3: customerData.address3 || "",
      city: customerData.city || "",
      postCode: customerData.postCode || "",
      state: customerData.state || "",
      country: customerData.country || "",
      adminUsername: customerData.adminUsername || "",
      adminEmailAddress: customerData.adminUserEmail || "",
      companyDomain: customerData.domains || "",
      subscriptionPlan: customerData.subscriptionPlan || "",
      subscriptionRenew: customerData.customerEndDate || "",
      aiSearch: customerData.aiSearch !== undefined ? customerData.aiSearch : false,
      url: customerData.logoUrl || "",
      primaryColor: customerData.masterColor || "",
      secondaryColor: customerData.secondaryColor || "",
      tertiaryColor: customerData.tertiaryColor || "",
    };
}

export const CustomerTableFactory = (customerData = {}) => {
  return {
    customerId: customerData.Customer_ID || "",
    customerName: customerData.Customer_Name || 'N/A',
    masterColor: customerData.Customer_MasterColors || 'N/A',
    secondaryColor: customerData.Customer_SecondaryColor || 'N/A',
    tertiaryColor: customerData.Customer_TertiaryColor || 'N/A',
    logoUrl: customerData.Customer_LogoURL || 'N/A',
    sso: customerData.Customer_SSO ? 'Active' : 'Inactive',
    domains: customerData.Customer_Domains || 'N/A',
    adminUsername: customerData.Admin_Username || 'N/A',
    adminUserEmail: customerData.Customer_AdminContactEmail || 'N/A',
    customerStartDate: customerData.Customer_StartDate || 'N/A',
    customerEndDate: customerData.Customer_EndDate || 'N/A',
    createdBy: customerData.CreatedBy || 'N/A',
    createdAt: customerData.CreatedDTTM || 'N/A',
    updatedBy: customerData.LastModifiedBy || 'N/A',
    updatedAt: customerData.LastModifiedDTTM || 'N/A',
    address1: customerData.CustomerAddress1 || 'N/A',
    address2: customerData.CustomerAddress2 || 'N/A',
    address3: customerData.CustomerAddress3 || 'N/A',
    subscriptionPlan: customerData.SubscriptionPlan || 'N/A',
    city: customerData.City || 'N/A',
    state: customerData.State || 'N/A',
    country: customerData.Country || 'N/A',
    postCode: customerData.Postcode || 'N/A',
    status: customerData.Customer_Status !== undefined ? customerData.Customer_Status : false,
    aiSearch: customerData.AISearchEnabled !== undefined ? customerData.AISearchEnabled : (customerData.AI_Search_Enabled !== undefined ? customerData.AI_Search_Enabled : false),
  }
}